import styled from "styled-components";

export const FaqContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 640px;
  font-family: "Geist", sans-serif;
  color: #181d27;

  .back-button {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    align-self: flex-start;
    margin-bottom: 16px;
    padding: 4px 8px 4px 4px;
    border: none;
    border-radius: 8px;
    background: transparent;
    font-family: "Geist", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #535861;
    cursor: pointer;
  }

  .back-button:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  .back-button:focus-visible,
  .faq-question:focus-visible {
    outline: 2px solid #181d27;
    outline-offset: 2px;
  }

  .panel-heading {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.2px;
  }

  .panel-subtitle {
    margin: 0;
    padding-top: 4px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #535861;
  }

  .faq-groups {
    padding-top: 16px;
  }

  .faq-group + .faq-group {
    padding-top: 36px;
  }

  .faq-section {
    margin: 0;
    padding-bottom: 8px;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.1px;
    color: #535861;
  }

  .faq-item {
    border-bottom: 0.909px solid rgba(0, 0, 0, 0.06);
  }

  .faq-question {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    padding: 14px 0;
    border: none;
    background: transparent;
    font-family: "Geist", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.1px;
    text-align: left;
    color: #181d27;
    cursor: pointer;
  }

  .faq-chevron {
    flex-shrink: 0;
    transition: transform 0.15s ease;
  }

  .faq-item.open .faq-chevron {
    transform: rotate(180deg);
  }

  .faq-answer {
    padding: 0 0 16px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.1px;
    color: #535861;
    overflow-wrap: anywhere;
  }

  .faq-answer a {
    color: #181d27;
    text-decoration: underline;
    cursor: pointer;
  }

  .faq-empty {
    padding: 16px 0;
    font-size: 14px;
    color: #535861;
  }
`;
